"use strict";
import {on, findAllIn, find} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
export function init() {
    onFind('.js-config-tracking', (baseElement) => {
        findAllIn('.js-config-tracking__btn', baseElement).forEach((element) => {
            on('click', (event) => {
                let step = find('.js-config-tracking__steps.is-current').getAttribute('data-event-tracking-step'),
                    maxStep = findAllIn('.js-config-tracking__steps', baseElement).length;
                console.log('complete', step === maxStep ? 'configuration_complete' : 'configuration_progress');
                window.dataLayer.push({
                    //'event': Number(step) === maxStep ? 'configuration_complete' : 'configuration_progress',
                    'event': 'configuration_progress',
                    'product_brand': element.getAttribute('data-event-tracking-product_brand'),
                    'product_variant': element.getAttribute('data-event-tracking-product_variant'),
                    'product_category': element.getAttribute('data-event-tracking-product_category'),
                    'step': step,
                    'max_step': maxStep,
                });
            }, element);
        });
    });
}